var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feet" },
    [
      _c(
        "el-button",
        {
          attrs: { type: "primary", size: "small" },
          on: {
            click: function ($event) {
              return _vm.downloadTemplate(1)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheTemplate")))]
      ),
      _c("upload-excel", {
        directives: [
          {
            name: "permit",
            rawName: "v-permit:remove",
            value: "but:finance:basicData:partition:edit",
            expression: "'but:finance:basicData:partition:edit'",
            arg: "remove",
          },
        ],
        staticClass: "feet-btn",
        attrs: { "on-success": _vm.importLogistics, "but-name": _vm.fileName },
      }),
      _c(
        "el-button",
        {
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.downloadLogistics },
        },
        [_vm._v(_vm._s(_vm.$t("basicData.DownloadThePartition")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }